// removed by extract-text-webpack-plugin
module.exports = {"pgs":"pgs","dashboard-chart-list":"dashboard-chart-list","report-chart":"report-chart","ant-col-8":"ant-col-8"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pgs/dashboard/index.scss
// module id = 1429
// module chunks = 0